// Script para manejar las vistas previas flotantes en el megamenú
// Este script está desactivado para evitar conflictos con megamenu-preview.js
console.log('custom-megamenu.js está desactivado para evitar conflictos');
